export const itemTypes = [
  {
    id: "physicians",
    label: "Physician",
    value: "physician"
  },
  {
    id: "hospitals",
    label: "Hospital",
    value: "hospital"
  },
  {
    id: "clinics",
    label: "Clinic",
    value: "clinic",
  },
  {
    id: "ohcp",
    label: "Allied Healthcare Professional",
    value: "other healthcare"
  },
  {
    id: "nfp",
    label: "Non-For-Profit",
    value: "nfp"
  },
  // {
  //   id: "Businesses",
  //   label: "Businesses",
  //   value: "businesses"
  // }
];
